import React from 'react';
import ProductMainHeading from '@components/molecules/products/product-main-heading/product-main-heading';
import ProductTags from '@components/molecules/products/product-tags/product-tags';
import ProductGallery from '@components/molecules/products/product-gallery/product-gallery';
import ProductDetails from '@components/molecules/products/product-details/product-details';
import ProductLikeButton from '@components/atoms/product-like-button/product-like-button';
import useProductQuery from '@hooks/product/use-product-query';
import useFeatureFlag from '@hooks/use-feature-flags';
import clsx from 'clsx';
import styles from './pdp-top.module.scss';

type PdpTopProps = {
  isWelcomeOfferLDFlagEnabled?: boolean;
};

const PdpTop: React.FC<PdpTopProps> = ({ isWelcomeOfferLDFlagEnabled }) => {
  const { product } = useProductQuery();
  const { isSemPDP } = useFeatureFlag();

  return (
    <div className={styles.pdpTop}>
      <div className={styles.pdpTop__title}>
        <ProductMainHeading />
        <ProductTags product={product} />
      </div>
      <div className={clsx(styles.pdpTop__image, { [styles['pdpTop__image--semPdpIteration']]: isSemPDP })}>
        <div
          className={clsx(styles.pdpTop__image__like, { [styles['pdpTop__image__like--semPdpIteration']]: isSemPDP })}
        >
          <ProductLikeButton
            product={product}
            pageType="product_page"
            showLikeCount={true}
          />
        </div>
        <ProductGallery
          pictures={product?.pictures}
          productPath={product?.path}
          defaultAlt={`${product?.brand?.name} ${product?.color?.name} ${product?.name}`}
        />
      </div>
      <div className={styles.pdpTop__infos}>
        <ProductDetails isWelcomeOfferLDFlagEnabled={isWelcomeOfferLDFlagEnabled} />
      </div>
    </div>
  );
};

export default PdpTop;
